import { createElement } from 'react';
import { isEpicValueCarouselActive, getLocale } from './isEpicValueCarouselActive';
import { prepareEpicValueContainer, WORLD_CUP_KEY } from './createEpicValueContainer';
import { EpicValueCarousel } from '@sb/sb-epic-value-carousel';
import { render } from '../../libs/ngsModuleLoader';

const getDomain = () => window.WH.sportsbook.sportsDomain;
const getConsole = () => window.consoleReference || window.console;

const getDataUrl = (locale) => {
    const dataFileName = `epicValueCarousel-${locale}.json`;
    return `https://${getDomain()}/data/homepage/${dataFileName}`;
};

export const renderEpicValueCarousel = (type) => {
    if (!isEpicValueCarouselActive()) return;

    const container = prepareEpicValueContainer(type);

    if (!container) {
        getConsole().warn('No container for Epic Value Carousel:', type);
        return;
    }

    const locale = getLocale();
    const dataUrl = getDataUrl(locale);
    const showSectionHeader = type !== WORLD_CUP_KEY;
    const backgroundColor = type === WORLD_CUP_KEY ? 'transparent' : 'white';

    render(container, { uiKit: true }, ({ device, navigate }) => {
        return createElement(EpicValueCarousel, {
            dataUrl,
            locale,
            device,
            navigate,
            backgroundColor,
            showSectionHeader,
        }, null);
    });
};
